import React, { useEffect, useState } from "react";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
const PresidentMessage = () => {
    return (
        <>
            <Header />
            <Breadcrumb
                title="President’s Message"
                midBreadcrumb="Message"
                mainBreadcrumb="President’s Message"
            />
            <div className='inner-page message'>
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="clearfix">
                                <h2 class="mainhead" data-aos="fade-right" data-aos-duration="1000">President’s Message</h2>
                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/president.png"
                                    class="col-md-5 float-md-end rit-img mx-auto d-block"
                                    alt="Mata Mariam Jan Seva Vidyalay" />
                                <p>Whenever we see ourselves drawing towards the end of an era we start to look back at where it all began.
                                    It is hard to believe that it was 11 years ago that I put the MMJSV uniform on for the very first time,
                                    but now I am in senior secondary and I am a leader of the most reputed school in the city. 2017 has proved
                                    to be such a pinnacle in an amazing time at Mata Mariam Jan Seva Vidyalaya, as it meant to be a jubileee
                                    year. To be named Head Boy for this year gave me an opportunity to give something back to a school which
                                    has served me for so many years.</p>
                                <p>The year boasted many positive changes. Our Principal father brought with him a fresh approach into
                                    leading the school, starting of MAT exams inculcating the all-round development as the top criteria.
                                    Moulding quickly into our culture we have come to know him as a man who thrives on getting amongst the
                                    student body while still maintaining a serious role in the classroom and in school life.</p>
                                <p>It is at this stage that I would like to say thank-you to those who have given so much to the success of
                                    all of us as students throughout our time here at MMJSV. On behalf of my cabinet, I thank our father
                                    manager Rev. Fr. Anthony Mario Fernandes SFX, Our Principal Rev. Fr. Maria Michael SFX and Headmistress
                                    Rev. Sr. Ajaya FSLG for their guidance and help throughout 2017. I thank all of the teachers for their
                                    commitment to carrying on the spirit of Mata Mariam Jan Seva Vidyalaya.</p>
                                <p>Sincerely,</p>
                                <p ><strong>Most Rev. Archbishop Anil
                                    Couto<br />President</strong></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default PresidentMessage